import * as React from 'react';
import Accordion, { AccordionProps } from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Divider } from '@mui/material';
import { styled as _styled } from '@mui/material/styles';
import styled from 'styled-components';
import { theme } from '../../../../../helpers/theme';

export type FaqArrayProps = {
  key: number;
  question: string;
  answer: string;
  content: string;
  header: string;
};
export interface QuestionCategoryProps {
  listTitle: string;
  questionList: FaqArrayProps[];
}

export const QuestionCategory = ({ listTitle, questionList }: QuestionCategoryProps) => {
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <ContainerFaq>
      <Subtitle dangerouslySetInnerHTML={{ __html: listTitle }} />
      {questionList.map(item => (
        <StyledAccordion
          disableGutters
          key={item.key}
          expanded={expanded === `${item.key}`}
          onChange={handleChange(`${item.key}`)}
        >
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                sx={{
                  color: `${theme.colors.gray01_secondaryText}`,
                  '&:hover': {
                    color: `${theme.colors.black_primaryText}`,
                  },
                }}
              />
            }
            aria-controls={item.content}
            id={item.header}
            sx={{
              color: `${theme.colors.black_primaryText}`,
            }}
          >
            <Typography
              sx={{
                width: '100%',
                fontFamily: `${theme.fonts.interRegular}`,
                fontSize: '14px',
                interLine: '20px',
                flexShrink: 0,
                fontWeight: `${theme.fontWeight.small}`,
                color: `${theme.colors.gray01_secondaryText}`,
                '&.active, &:hover, &.active:hover': {
                  color: `${theme.colors.black_primaryText}`,
                },
              }}
              dangerouslySetInnerHTML={{ __html: item.question }}
            />
          </AccordionSummary>
          <AccordionDetails>
            <Divider
              sx={{
                color: `${theme.colors.gray03_border2}`,
                marginBottom: '24px',
              }}
            />
            <Typography
              sx={{
                fontSize: '14px',
                interLine: '20px',
                fontFamily: `${theme.fonts.interRegular}`,
                color: `${theme.colors.gray01_secondaryText}`,
                fontWeight: `${theme.fontWeight.small}`,
              }}
              dangerouslySetInnerHTML={{ __html: item.answer }}
            />
          </AccordionDetails>
        </StyledAccordion>
      ))}
    </ContainerFaq>
  );
};

const Subtitle = styled.p`
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
const ContainerFaq = styled.div`
  padding-bottom: 30px;
`;

const StyledAccordion = styled((props: AccordionProps) => <Accordion {...props}>{props.children}</Accordion>)(
  ({}) => ({
    backgroundColor: 'green',
    borderRadius: '8px !important',
    marginBottom: '5px',
  })
);

const AccordionSummary = _styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={<ExpandMoreIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
))(({}) => ({
  '& .Mui-expanded': {
    color: `${theme.colors.black_primaryText}`,
    '& p': {
      color: `${theme.colors.black_primaryText}`,
    },
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    '& svg': {
      color: `${theme.colors.black_primaryText}`,
    },
  },
}));
